import Api from './api.service';
export default {
  get(params) {
    return Api().get('/addon-types', { params });
  },
  save(data) {
    return Api().post('/addon-types', data);
  }
};
